import {
  CameraFacing,
  useImagePickerContext,
} from '../../providers/ImagePickerProvider'

interface UseImagePickerReturn {
  openCamera: (cameraFacing?: CameraFacing) => Promise<File>
  openGallery: () => Promise<File>
}

export function useImagePicker(): UseImagePickerReturn {
  const {openCamera, openGallery} = useImagePickerContext()

  return {
    openCamera,
    openGallery,
  }
}
